import React from 'react';
import { dashboardApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

function StatCard({ label, value }) {
  return (
    <div className="glass rounded-xl p-5">
      <p className="text-white/50 text-sm">{label}</p>
      <p className="text-3xl font-bold mt-1">{value}</p>
    </div>
  );
}

export default function DashboardHome() {
  const { data, loading, error, reload } = useApiData(() => dashboardApi.get());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      <StateBlock loading={loading} error={error} onRetry={reload}>
        {data && (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              <StatCard label="Devices" value={`${data.stats.online_devices}/${data.stats.total_devices}`} />
              <StatCard label="Rooms" value={data.stats.rooms} />
              <StatCard label="Cameras" value={`${data.stats.online_cameras}/${data.stats.total_cameras}`} />
              <StatCard label="Active automations" value={data.stats.active_automations} />
            </div>

            <h2 className="text-lg font-semibold mb-3">Favorite devices</h2>
            {data.favorites?.length ? (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {data.favorites.map((d) => (
                  <div key={d.id} className="glass rounded-xl p-4">
                    <p className="font-medium">{d.name}</p>
                    <p className="text-xs text-white/40">{d.device_type}</p>
                    <span className={`inline-block mt-2 text-xs px-2 py-0.5 rounded-full ${d.is_online ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white/40'}`}>
                      {d.is_online ? 'Online' : 'Offline'}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-white/40">No favorite devices yet.</p>
            )}
          </>
        )}
      </StateBlock>
    </div>
  );
}
